/* import __COLOCATED_TEMPLATE__ from './sq-option-switch.hbs'; */
/**
A Switch toggle with a label

```example
@title Basic Usage
@description Pass a label and optional secondary label.

@hbs
{{sq-option-switch name="option-switch"
                   label="Off (Default)"}}

{{sq-option-switch name="option-switch-on"
                   checked=true
                   label="On"}}

{{sq-option-switch name="option-switch-disabled"
                   disabled=true
                   label="Off (Disabled)"}}

{{sq-option-switch name="option-switch-disabled-on"
                   checked=true disabled=true
                   label="On (Disabled)"}}
```

```example
@title With Secondary Text
@description You can pass a secondary label to the switch

@hbs
{{sq-option-switch name="option-switch-with-secondary-label"
                   label="Off"
                   labelSecondary="Default"}}

{{sq-option-switch name="option-switch-with-secondary-label-on"
                   checked=true
                   label="On"
                   labelSecondary="Default"}}

{{sq-option-switch name="option-switch-with-secondary-label-disabled"
                   disabled=true
                   label="Off"
                   labelSecondary="Disabled"}}

{{sq-option-switch name="option-switch-with-secondary-label-disabled-on"
                   checked=true
                   disabled=true
                   label="On"
                   labelSecondary="Disabled"}}
```

```example
@title Contextual Labels
@description If you need to do some sort of fancy formatting for your labels, you can output each one
separately using contextual components

@hbs
{{#sq-option-switch name="option-switch-block" as |switch|}}
  {{#switch.label}}
    {{svgs/alert-icon}} Oh No, something is wrong
  {{/switch.label}}
  {{#switch.label-secondary}}
    Please correct this <em>egregious</em> error.
  {{/switch.label-secondary}}
{{/sq-option-switch}}

```

```example
@title Block Content
@description You can also yield completely custom content in addition to the primary
and secondary labels by passing a block directly to the switch option

@hbs
{{#sq-option-switch name="option-switch-block"
                   label="Select this custom option"}}
  <input class="input" type="text" placeholder="some kind of extra field">
{{/sq-option-switch}}

```

@param {String} label - The primary label for this field
@param {String} labelSecondary - Optional. Secondary label for this field.
@param {String} name - A name for this field.
@param {Any} value - A value that this switch represents. (NOT the switch's state. Use the `checked` param for boolean state. The value should be a meaningful or javascript object.)
@param {Boolean/String} [checked=false]
@param {Boolean} [disabled=false] - Disable the switch
@param {Number} [tabindex=0] - passes through to the input giving it a tabindex for keyboard navigation
@param {Function} action - An action to perform when the value of 'checked' changes. Is passed the new 'checked' value of the switch, along with the switch's value
*/
import Component from '@ember/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'label',
  classNames: ['option', 'option--switch'],
  classNameBindings: ['checked:option--is-selected', 'checked:switch-option--is-on', 'disabled:option--is-disabled'],
  attributeBindings: ['data-test-option-switch', 'data-test-option-switch-checked'],
  'data-test-option-switch': computed('label', 'value', function () {
    return this.get('label') || this.get('value') || true;
  }),
  'data-test-option-switch-on': readOnly('checked'),
  checked: false
});